import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { USER_DETAIL } from '../constants/routes';

const UserTableItem = (props) => {
	const { user, onDeleteClick, role } = props;

	return (
		<tr>
			<td>{user.id}</td>
			<td><Link to={`${USER_DETAIL}?id=${user.id}`}>{user.email}</Link></td>
			<td><Link to={`${USER_DETAIL}?id=${user.id}`}>{user.fio}</Link></td>
			<td>{moment(user.lastSeen).format('YYYY-MM-DD HH:mm:ss')}</td>
			<td>{role.length ? role[0].label : ''}</td>
			<td>{role.length ? <button className="btn btn-danger" onClick={() => onDeleteClick(user.id)}>Удалить</button> : null}</td>
		</tr>
	)
}

UserTableItem.propTypes = {
	user: PropTypes.object.isRequired,
	role: PropTypes.array.isRequired,
	onDeleteClick: PropTypes.func.isRequired
}

export default UserTableItem;



// WEBPACK FOOTER //
// ./components/UserTableItem.js